import { TinyColor } from '@ctrl/tinycolor';
import { create } from 'zustand';

// Colors for tests : #D1E9FA / #0A4066 / #4caf50 /03a574
// const tinyColorObj = new TinyColor(rootOrganization.brand.style.mainColor);
// const isLight = tinyColorObj.isLight();
// const dynamicBackgroundColor = tinyColorObj.toString();
// const dynamicTextColor = isLight ? tinyColorObj.darken(70).toString() : tinyColorObj.brighten(90).toString();

const useColorsStore = create((set) => ({
    dynamicBackgroundColor: null,
    setColor: (rootOrganizationColor) => set(() => {
        const tinyColorObj = new TinyColor(rootOrganizationColor);
        return ({ dynamicBackgroundColor: tinyColorObj.toString() });
    }),
    dynamicTextColor: null,
    setTextColor: (rootOrganizationColor) => set(() => {
        const tinyColorObj = new TinyColor(rootOrganizationColor);
        return ({ dynamicTextColor: tinyColorObj.isLight() ? tinyColorObj.darken(70).toString() : tinyColorObj.brighten(90).toString() });
    }),
    isLight: null,
    setIsLight: (rootOrganizationColor) => set(() => {
        const tinyColorObj = new TinyColor(rootOrganizationColor);
        return ({ isLight: tinyColorObj.isLight() });
    }),
    dynamicEnlightedColor: null,
    setDynamicEnlightedColor: (rootOrganizationColor) => set(() => {
        const hslValue = new TinyColor(rootOrganizationColor).toHsl();
        hslValue.l = 0.95;
        return ({ dynamicEnlightedColor: new TinyColor(hslValue).toHslString() });
    })
}));

export default useColorsStore;